export enum RenewablesProductsEnum {
  WIND = 'wind',
  SOLAR = 'solar',
  TOTAL = 'total',
}
